import React, { Component } from 'react';
import AppBar from './AppBar';
import VirtualizedList from './VirtualizedList';
import { IPedido, IFilter } from '../types';
import SearchField from './SearchField';
import OrderService from '../ApiClients/OrderService';
import PedidoListItem from './PedidoListItem';
import Loader from './Loader';
import {cloneDeep, filter, includes} from 'lodash';
import { Box, Tab, Tabs, Button, IconButton, Tooltip, CircularProgress } from '@mui/material';
import { withParamsAndNavigate } from './Material/ReactRouter';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import RefreshIcon from '@material-ui/icons/Refresh';

interface DateFilterBarProps {
    dateFrom: Date;
    dateTo: Date;
    loading: boolean;
    onDateFromChange: (date: MaterialUiPickersDate) => void;
    onDateToChange: (date: MaterialUiPickersDate) => void;
    onAplicar: () => void;
    onLimpiar: () => void;
    mobile?: boolean;
}

const DateFilterBar: React.FC<DateFilterBarProps> = ({ dateFrom, dateTo, loading, onDateFromChange, onDateToChange, onAplicar, onLimpiar, mobile }) => (
    <Box sx={{
        display: mobile ? { xs: 'flex', md: 'none' } : { xs: 'none', md: 'flex' },
        alignItems: 'center',
        gap: '6px',
        ...(mobile ? { width: '100%', boxSizing: 'border-box', marginTop: '4px' } : {}),
    }}>
        {mobile ? (
            <>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                        <DatePicker label="Desde" value={dateFrom} onChange={onDateFromChange} format="dd/MM/yyyy" style={{ width: '100%' }} />
                    </MuiPickersUtilsProvider>
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                        <DatePicker label="Hasta" value={dateTo} onChange={onDateToChange} format="dd/MM/yyyy" style={{ width: '100%' }} />
                    </MuiPickersUtilsProvider>
                </Box>
            </>
        ) : (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                <DatePicker label="Desde" value={dateFrom} onChange={onDateFromChange} format="dd/MM/yyyy" style={{ width: '90px' }} />
                <DatePicker label="Hasta" value={dateTo} onChange={onDateToChange} format="dd/MM/yyyy" style={{ width: '90px' }} />
            </MuiPickersUtilsProvider>
        )}
        <Button
            variant="outlined"
            onClick={onAplicar}
            disabled={loading}
            size="small"
            sx={{ fontSize: '0.75rem', padding: '4px 12px', whiteSpace: 'nowrap' }}
        >
            {loading ? <CircularProgress size={16} color="inherit" /> : 'Aplicar'}
        </Button>
        <Tooltip title="Restablecer filtros">
            <span>
                <IconButton
                    onClick={onLimpiar}
                    disabled={loading}
                    size="small"
                    sx={{
                        color: '#284770',
                        ...(mobile ? {
                            border: '1px solid #284770',
                            borderRadius: '4px',
                            padding: '5px',
                            '&:hover': { backgroundColor: 'rgba(40, 71, 112, 0.08)' }
                        } : {}),
                    }}
                >
                    {loading ? <CircularProgress size={mobile ? 18 : 16} color="inherit" /> : <RefreshIcon fontSize="small" />}
                </IconButton>
            </span>
        </Tooltip>
    </Box>
);

interface IRetiradasProps {
    params?:any;
    navigate?:any;    
    title: string;
    filters: IFilter;
    handleChangeFilter: Function;
}

interface IRetiradasState {
    pedidos?: Array<IPedido>;
    searchValue: string;
    loading: boolean;
    filteredPedidos: Array<IPedido>;
    tabPedidos: number;
    pendientes: boolean;
    inset_content: string;
    filter_id: string;
    dateFrom: Date;
    dateTo: Date;
}

class Retiradas extends Component<IRetiradasProps, IRetiradasState> {
    constructor(props: IRetiradasProps) {
        super(props);

        const today = new Date();
        const weekAgo = new Date();
        weekAgo.setDate(weekAgo.getDate() - 7);

        this.state = {
            pedidos: undefined,
            filteredPedidos:[],
            searchValue: '',
            loading: true,
            tabPedidos: 0,
            pendientes: true,
            inset_content: '60px 0 0',
            filter_id: "f_retiradas",
            dateFrom: weekAgo,
            dateTo: today,
        };
    }

    componentDidMount() {
        this.loadPedidos();
    }

    handleChangeFilter=(id:string, evt:any)=>{
        let newFilters = cloneDeep(this.props.filters[this.state.filter_id] || {});
        newFilters[id] = evt.target.value;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);
    }

    handleDateFromChange = (date: MaterialUiPickersDate) => {
        if (date) this.setState({ dateFrom: date });
    }

    handleDateToChange = (date: MaterialUiPickersDate) => {
        if (date) this.setState({ dateTo: date });
    }

    handleAplicarFiltros = () => {
        this.setState({ loading: true }, () => {
            this.loadPedidosWithRefresh();
        });
    }

    handleLimpiarFiltros = () => {
        const today = new Date();
        const weekAgo = new Date();
        weekAgo.setDate(weekAgo.getDate() - 7);
        this.setState({ dateFrom: weekAgo, dateTo: today, loading: true }, () => {
            this.loadPedidosWithRefresh();
        });
    }

    formatDate = (date: Date): string => date.toISOString().split('T')[0];

    loadPedidos = async () => {
        const useDates = this.state.tabPedidos === 1;
        let pedidos = await OrderService.getPedidos(false, 3, useDates ? this.formatDate(this.state.dateFrom) : undefined, useDates ? this.formatDate(this.state.dateTo) : undefined);

        if (pedidos !== undefined) {
            this.setState({
                pedidos: pedidos,
                loading: false,
                searchValue: (this.props.filters[this.state.filter_id] && 'searchbar' in this.props.filters[this.state.filter_id]) 
                    ? this.props.filters[this.state.filter_id]['searchbar'] 
                    : '',
            }, () => {
                this.handleFilterPedidos();
            });
        } else {
            this.setState({ loading: false });
        }
    }

    loadPedidosWithRefresh = async () => {
        const useDates = this.state.tabPedidos === 1;
        let pedidos = await OrderService.getPedidos(true, 3, useDates ? this.formatDate(this.state.dateFrom) : undefined, useDates ? this.formatDate(this.state.dateTo) : undefined);

        if (pedidos !== undefined) {
            this.setState({
                pedidos: pedidos,
                loading: false,
                searchValue: (this.props.filters[this.state.filter_id] && 'searchbar' in this.props.filters[this.state.filter_id]) 
                    ? this.props.filters[this.state.filter_id]['searchbar'] 
                    : '',
            }, () => this.handleFilterPedidos());
        }
    }

    handleValueChange = (evt: any) => {
        let newFilters = cloneDeep(this.props.filters[this.state.filter_id] || {});
        newFilters["searchbar"] = evt.target.value;

        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

        this.setState({ 
            searchValue: evt.target.value,
        }, () => this.handleFilterPedidos())
    }

    handleFilterPedidos = () => {
        const tabPedidos = this.state.tabPedidos;

        // Solo filtrar si hay datos cargados
        if (this.state.pedidos === undefined) {
            return;
        }
        
        let newPedidos = cloneDeep(this.state.pedidos);
        let newFilters = cloneDeep(this.props.filters[this.state.filter_id] || {});
        
        this.setState({
            pendientes: tabPedidos === 0, 
            inset_content: (tabPedidos === 0) ? '60px 0 0': '0 0 0'
        });
        
        // Tab Pendientes: excluir estados finalizados
        if (tabPedidos === 0) {
            newPedidos = filter(newPedidos, function(o) { return ![50, 98, 99].includes(o.status) });
        }
                
        //** FILTRA POR EL VALOR DE BÚSQUEDA */
        const searchValue = this.state.searchValue.toLowerCase();
        
        newFilters["searchbar"] = searchValue;
        this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

        if (newPedidos.length > 0 && searchValue && searchValue.length > 0) {
            newPedidos = filter(newPedidos, function(o) {
                return includes(o.farm?.id.toLowerCase(), searchValue) || 
                       includes(o.farm?.name.toLowerCase(), searchValue) || 
                       includes(o.idPedido ? o.idPedido.toLowerCase() : "", searchValue);
            });
        }

        this.setState({
            filteredPedidos: newPedidos
        })
    }

    handleItemClick = (pedido: IPedido, i: number) => {
        const pedidoRef = (pedido as any).idPedido ?? String((pedido as any).id ?? '');
        this.props.navigate(`/retirada/${pedido.business}/${pedidoRef}`);
    }

    renderPedidos = () => {
        if (this.state.loading) {
            return (
                <div style={{marginLeft:'50%', marginTop:200}}>
                    <Loader loading={true}/>
                </div>
            );
        }

        const {filteredPedidos, tabPedidos} = this.state;

        if (filteredPedidos.length === 0) {
            let mensaje = tabPedidos === 0 
                ? 'No tiene retiradas pendientes para visualizar.'
                : 'No tiene retiradas para visualizar.';
            return (
                <div style={{textAlign:'center', padding:50}}>
                    <p>{mensaje}</p>
                </div>
            )
        }

        let items = filteredPedidos.map((pedido, i) => {
            return {
                ...pedido,
                onItemClick: () => this.handleItemClick(pedido, i),
            }
        })
        
        return (
            <VirtualizedList items={items} RowComponent={PedidoListItem} itemSize={150} />
        );
    }

    handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        this.setState({
            tabPedidos: newValue,
            loading: true,
        }, () => {
            this.loadPedidosWithRefresh();
        });
    };

    render() {
        const {title} = this.props;
        const {tabPedidos} = this.state;

        return (
            <AppBar title={title} navigate={this.props.navigate}>
                <div style={{ paddingTop: '15px' }}>
                    <table style={{width:'100%'}}>
                        <tbody>
                            <tr>
                                <SearchField 
                                    allowSearch={this.state.loading} 
                                    value={this.state.searchValue} 
                                    onValueChange={this.handleValueChange} 
                                    placeholder="Buscar Retirada" 
                                />
                            </tr>
                            <tr>
                                <td>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        bgcolor: 'background.paper',
                                        marginLeft: '10px',
                                        marginRight: '10px',
                                        marginTop: '5px'
                                    }}>
                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}>
                                            <Tabs
                                                value={tabPedidos}
                                                onChange={this.handleChangeTab}
                                                aria-label="tabs retiradas"
                                            >
                                                <Tab label={`Pendientes`} />
                                                <Tab label={`Todos`} />
                                            </Tabs>
                                            {tabPedidos === 1 && (
                                                <DateFilterBar
                                                    dateFrom={this.state.dateFrom}
                                                    dateTo={this.state.dateTo}
                                                    loading={this.state.loading}
                                                    onDateFromChange={this.handleDateFromChange}
                                                    onDateToChange={this.handleDateToChange}
                                                    onAplicar={this.handleAplicarFiltros}
                                                    onLimpiar={this.handleLimpiarFiltros}
                                                />
                                            )}
                                        </Box>
                                        {tabPedidos === 1 && (
                                            <DateFilterBar
                                                dateFrom={this.state.dateFrom}
                                                dateTo={this.state.dateTo}
                                                loading={this.state.loading}
                                                onDateFromChange={this.handleDateFromChange}
                                                onDateToChange={this.handleDateToChange}
                                                onAplicar={this.handleAplicarFiltros}
                                                onLimpiar={this.handleLimpiarFiltros}
                                                mobile
                                            />
                                        )}
                                    </Box>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Box sx={{
                    position: 'absolute',
                    top: tabPedidos === 1 ? { xs: 175, md: 130 } : 130,
                    left: 0,
                    right: 0,
                    bottom: 0,
                }}>
                    {this.renderPedidos()}
                </Box>
            </AppBar>
        );
    }
}

export default withParamsAndNavigate(Retiradas);
